import { joinRouteMatchPath, ROUTES } from '@futrli/shared-services';
import { matchPath } from 'react-router-dom';

export const matchRegisterPath = (pathname: string): boolean => {
  const orgPath = joinRouteMatchPath('', ROUTES.REGISTER);

  return matchPath({ path: orgPath, end: false }, pathname) !== null;
};
